module.exports = __webpack_public_path__ + "static/media/hab9-2.5bfb5fc2.jpg";